export default __webpack_public_path__ + "static/media/world_flip.5cca40c5.gif";